// extracted by mini-css-extract-plugin
module.exports = {"theComp":"KSP4APP_theComp__TTX6a"};